// @flow

export const FILTER_SORT_WRAPPER_Z_INDEX = 900;
export const MODAL_CONTAINER_Z_INDEX = 100;
export const HEADER_BACK_BUTTON_Z_INDEX = 901; // global header set to 900;
export const HEADER_Z_INDEX = 900;
